import React, { useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { getConfirmableDeleteAndNavigateAction } from '@actions/data-detail-actions';
import { showConfirmationDialog } from '@actions/confirmation-actions';
import { fetchCycle } from '@actions/workflow-actions';
import DetailsContext from '@components/workflow/details-context';
import DeleteIcon from '@material-ui/icons/Delete';
import IconMenu from '@shared/icon-menu';
import IconMenuItem from '@shared/icon-menu-item';
import { getDashboardBackURL } from '@utils/navigation-utils';
import { canAccessWorkflow } from '@utils/permission-utils';
import './details-header.scss';

const DetailsHeader = ({ showDelete }) => {
  const dispatch = useDispatch();
  const { cycle, task, taskType } = useContext(DetailsContext);

  const deleteTask = useCallback(
    () => {
      const source = getDashboardBackURL(window.location, null, `/cycle/${cycle.id}/`);

      // Callback to reload the cycle after task deletion.
      // (to refresh the list of tasks).
      const callback = () => dispatch(fetchCycle(cycle.id));
      dispatch(showConfirmationDialog(
        'Delete task?',
        `Are you sure you want to delete task "${task.name}"?`,
        getConfirmableDeleteAndNavigateAction('task', 'task', task.id, source, callback)
      ));
    },
    [cycle, task, dispatch]
  );

  if (!cycle || !task) {
    return null;
  }

  const canDelete = canAccessWorkflow('task', 'delete');
  return (
    <div styleName="header">
      <div styleName="header-title">
        <div styleName="header-title-label">{task.name}</div>
        {showDelete && canDelete && (
          <div styleName="header-title-action">
            <IconMenu>
              <IconMenuItem key="delete" icon={<DeleteIcon />} onClick={deleteTask}>
                Delete task
              </IconMenuItem>
            </IconMenu>
          </div>
        )}
      </div>
      <div styleName="header-subtitle">
        {taskType.name}
      </div>
    </div>
  );
};

DetailsHeader.propTypes = {
  showDelete: PropTypes.bool
};

export default DetailsHeader;
